import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

// Public landing the invite email links to (buildBindUrl → /probe/bind?t=<token>).
// Two paths: "Connect" fires the rx2go-probe:// deep link into an installed agent;
// "Download agent" 302s to the current installer. No auth.
export default function ProbeBindPage() {
  const [params] = useSearchParams()
  const token = params.get('t') || ''
  const deepLink = useMemo(() => (token ? `rx2go-probe://bind?t=${encodeURIComponent(token)}` : ''), [token])

  return (
    <div className="min-h-screen grid place-items-center bg-background text-foreground p-6">
      <div className="w-full max-w-md rounded-xl border border-border bg-card p-8 text-center">
        <h1 className="text-xl font-bold">Connect your Rx2Go support agent</h1>
        {!token ? (
          <p className="mt-3 text-sm text-destructive">This link is missing its pairing token. Ask your contact for a fresh invite.</p>
        ) : (
          <>
            <p className="mt-3 text-sm text-muted-foreground">
              If the agent is already installed, click Connect. Otherwise download and install it first, then come back and click Connect.
            </p>
            <a
              href={deepLink}
              className="mt-6 inline-block w-full rounded-lg bg-primary px-4 py-2.5 font-medium text-primary-foreground hover:opacity-90 transition"
            >
              Connect
            </a>
            <a
              href="/api/download/probe-agent"
              className="mt-3 inline-block w-full rounded-lg bg-muted px-4 py-2.5 font-medium text-foreground hover:bg-muted/70 transition"
            >
              Download agent (Windows)
            </a>
            <a
              href="/api/download/probe-agent?variant=portable"
              className="mt-2 inline-block w-full rounded-lg bg-muted px-4 py-2.5 text-sm font-medium text-muted-foreground hover:bg-muted/70 transition"
            >
              Download portable (no install — Citrix)
            </a>
          </>
        )}
      </div>
    </div>
  )
}
